
// The solid-book-back Vercel project's production alias. It always points at
// the current production deployment, so it won't go stale like a pinned
// deployment URL (the old solid-book-back-stemmlerjs.vercel.app alias did).
const API_BASE_URL = 'https://solid-book-back-khalil-stemmlers-projects.vercel.app/src/functions';

export const apiUrls = {
  purchaseExists: `${API_BASE_URL}/purchase_exists.ts`,
  resendEmail: `${API_BASE_URL}/resend_email.ts`,
  chargeCustomer: `${API_BASE_URL}/charge_customer.ts`,
  submitFeedback: `${API_BASE_URL}/submit_feedback.ts`,
  generateDownloadLink: `${API_BASE_URL}/generate_download_link.ts`,
  totalNumPurchases: `${API_BASE_URL}/get_total_number_purchases.ts`,
  getAccount: `${API_BASE_URL}/get_account.ts`,
  assignBook: `${API_BASE_URL}/assign_book.ts`
}
